import {
  getTextResultsRequest,
  getTextResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/text-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchTextResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchTextResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchTextResultsParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey('text', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getTextResultsRequest,
    getResponse: getTextResultsResponse,
  });
};
